import {useTranslate} from '../lib/i18n.js';

export default function NotFoundPage() {
  const t = useTranslate();
  return (
    <s-page heading={t('loadFailed')}>
      <s-section>
        <s-grid gap="base" justifyItems="center" paddingBlock="large-400">
          <s-button href="/">{t('back')}</s-button>
        </s-grid>
      </s-section>
    </s-page>
  );
}
